import { render, staticRenderFns } from "./SecaoInclusaoDigitalSaude.vue?vue&type=template&id=4e9cd9b4&scoped=true"
import script from "./SecaoInclusaoDigitalSaude.vue?vue&type=script&lang=js"
export * from "./SecaoInclusaoDigitalSaude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cd9b4",
  null
  
)

export default component.exports